// extracted by mini-css-extract-plugin
export default {"container":"PortfolioProjectList_container__4VCqa","list-container":"PortfolioProjectList_list-container__g31s2"};